import React from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'

import Link from '../Link'

const Links = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${Link} {
    flex-grow: 1;
    justify-content: center;
    color: var(--color-gray-50) !important;
  }
`

function Bottom() {
  const { t, i18n } = useTranslation()

  return (
    <Links>
      <Link href={`https://legal.rdstation.com/${i18n.language}/privacy-policy/`} target="_blank">
        {t('LoginForm.PrivacyPolicy')}
      </Link>
    </Links>
  )
}

export default Bottom
